import moment from 'moment-timezone';

export function setMomentTimezone(timezone: string) {
  moment.tz.setDefault(timezone);
}

export function momentDate(date: Date) {
  return moment(date);
}
